export function selectionCheckboxId(scope: string, id: string): string {
  return `select-${scope}-${id}`;
}

export function selectionLabelClass(
  isDisabled: boolean,
  display: 'inline-flex' | 'flex' = 'inline-flex'
): string {
  return `${display} items-center gap-2 ${
    isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
  }`;
}
